import { Space, Tooltip } from "antd";
import DeletedSubmittalTag from "components/deleted-submittal-tag";
import SubmittalIcon from "components/svg-icons/submittal-icon-2";
import VoidSubmittalIcon from "components/svg-icons/void-submittal-icon";
import { EWorkflowStatusDataBlock } from "constants/index";
import { ProjectContext } from "context/ProjectProvider";
import { TLinkSource } from "components/feature-entity-linking-page/models";
import { useContext, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { mergedStrings } from "utils/utils";
import { specSectionLabel } from "components/cell-renders";

function FeatureRowSubmittalCard({
  item,
  isEditing,
  onRemoveRow
}: {
  item: TLinkSource;
  isEditing: boolean;
  onRemoveRow: (rowId: string) => void;
}) {
  const { projectId } = useParams() as any;
  const { projectDetails } = useContext(ProjectContext);
  const submittal = item.feature_instance!;

  const specDetail = useMemo(() => {
    const specSection = submittal.feature_instance_spec_sections.length
      ? submittal.feature_instance_spec_sections[0].spec_section
      : {
          section_number: "",
          title: ""
        };

    const specString = specSectionLabel({
      specNumber: specSection.section_number,
      specName: specSection.title
    });

    const submittalId = projectDetails?.spec_section
      ? mergedStrings([
          specSection.section_number ?? "",
          String(submittal.auto_inc_value ?? "")
        ])
      : submittal?.auto_inc_value;

    return {
      ...specSection,
      specString,
      submittalId
    };
  }, [
    projectDetails?.spec_section,
    submittal.auto_inc_value,
    submittal.feature_instance_spec_sections
  ]);

  return (
    <div className="border border-color px-1 py-2 bg-white rounded mb-2 flex items-center features-card">
      <div>
        {submittal?.deleted_from_source && (
          <DeletedSubmittalTag data-testid="featurerowsubmittalcard-deleted-tag" />
        )}

        {!submittal?.deleted_from_source &&
          submittal.feature_workflow_instance?.workflow_status ===
            (EWorkflowStatusDataBlock.VOID as string) && (
            <VoidSubmittalIcon data-testid="featurerowsubmittalcard-void-icon" />
          )}

        {!submittal?.deleted_from_source &&
          submittal.feature_workflow_instance?.workflow_status !==
            (EWorkflowStatusDataBlock.VOID as string) && (
            <SubmittalIcon
              size={20}
              fill="#a8a8a8"
              className="grow-none"
              data-testid="featurerowsubmittalcard-submittal-icon"
            />
          )}
      </div>
      <Tooltip
        title={submittal.title}
        data-testid="featurerowsubmittalcard-tooltip"
      >
        <div className="flex-grow align-center truncate">
          <Link
            className="grow-none"
            to={`/project/${projectId}/submittals/${submittal.id}`}
            data-testid="featurerowsubmittalcard-link-submittal-id"
          >
            <i
              className="entity-id-with-spec"
              data-testid="featurerowsubmittalcard-submittal-id"
            >
              {specDetail.submittalId}
            </i>
          </Link>
          <i
            className="entity-id-with-spec"
            data-testid="featurerowsubmittalcard-spec-string"
          >
            {specDetail.specString}
          </i>
          &nbsp;&nbsp;
          <span data-testid="featurerowsubmittalcard-title">
            {submittal?.title}
          </span>
        </div>
      </Tooltip>
      {isEditing && (
        <Space
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onRemoveRow(submittal.id);
          }}
          className="unlink-button grow-none"
          data-testid="featurerowsubmittalcard-unlink-button"
        >
          Unlink
        </Space>
      )}
    </div>
  );
}

export default FeatureRowSubmittalCard;
